module.exports = __webpack_public_path__ + "static/media/TWI CAROUSEL 02.2bab88d3.jpg";